import { useQuery } from '@tanstack/react-query';
import { timetableApi } from '../api/timetable';
import { QUERY_KEYS } from '../utils/constants';

export function useTimetable(params?: {
  location_id?: string;
  coach_id?: string;
  day?: string;
  target_date?: string;
}) {
  return useQuery({
    queryKey: [QUERY_KEYS.timetable, params],
    queryFn: () => timetableApi.getWeekly(params),
    staleTime: 10 * 60 * 1000,
  });
}
